"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIUtil = void 0;
const os = __importStar(require("os"));
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const cli_core_1 = require("@/cli-core");
const cli_api_1 = require("@/cli-api");
const types_1 = require("@/types");
/**
 * 统一配置文件名称
 */
const CONFIG_FILE_NAME = 'config.json';
/**
 * AI 与 Ollama 共享工具类，负责跨平台安装、服务托管、环境配置、配置持久化与连通性校验
 */
exports.AIUtil = {
    /**
     * 获取统一的 CLI 配置文件路径 (~/.coda/config.json)
     * 存放在用户家目录下，彻底解决 Linux/macOS/Windows 全局安装时的非 root 权限不足问题
     * @returns 路径字符串
     */
    getConfigPath() {
        const homeDir = os.homedir();
        const configDir = path.join(homeDir, '.coda');
        if (!fs.existsSync(configDir)) {
            try {
                fs.mkdirSync(configDir, { recursive: true });
            }
            catch (e) {
                // 兜底策略：如果家目录不可写，退回到系统临时目录
                return path.join(os.tmpdir(), 'coda', CONFIG_FILE_NAME);
            }
        }
        return path.join(configDir, CONFIG_FILE_NAME);
    },
    /**
     * 获取本地缓存的 Ollama 配置
     * @returns 配置对象
     */
    getOllamaConfig() {
        const configPath = this.getConfigPath();
        if (fs.existsSync(configPath)) {
            try {
                const raw = fs.readFileSync(configPath, 'utf8');
                const data = JSON.parse(raw);
                return data.ollama || {};
            }
            catch (e) {
                return {};
            }
        }
        return {};
    },
    /**
     * 保存 Ollama 配置到统一本地缓存并标记已配置
     * @param config 配置对象
     */
    saveOllamaConfig(config) {
        const configPath = this.getConfigPath();
        let data = {};
        if (fs.existsSync(configPath)) {
            try {
                data = JSON.parse(fs.readFileSync(configPath, 'utf8'));
            }
            catch (e) {
                data = {};
            }
        }
        data.ollama = {
            ...(data.ollama || {}),
            ...config,
            isConfigured: true,
        };
        const dir = path.dirname(configPath);
        if (!fs.existsSync(dir)) {
            fs.mkdirSync(dir, { recursive: true });
        }
        fs.writeFileSync(configPath, JSON.stringify(data, null, 2), 'utf8');
    },
    /**
     * 加载本地保存的 AI 设置配置
     * @returns 返回解析后的 AISetting 对象，若不存在或损坏则返回 null
     */
    loadSavedAISetting() {
        try {
            const configPath = this.getConfigPath();
            if (fs.existsSync(configPath)) {
                const raw = fs.readFileSync(configPath, 'utf8');
                const data = JSON.parse(raw);
                const setting = data.aiSetting;
                if (setting && setting.baseUrl && setting.model && setting.options) {
                    return setting;
                }
            }
        }
        catch (e) { }
        return null;
    },
    /**
     * 保存 AI 设置配置到统一的 config.json 文件中
     * @param settings AI 设置对象
     */
    saveAISetting(settings) {
        try {
            const configPath = this.getConfigPath();
            const dir = path.dirname(configPath);
            if (!fs.existsSync(dir)) {
                fs.mkdirSync(dir, { recursive: true });
            }
            let data = {};
            if (fs.existsSync(configPath)) {
                try {
                    data = JSON.parse(fs.readFileSync(configPath, 'utf8'));
                }
                catch (e) {
                    data = {};
                }
            }
            data.aiSetting = settings;
            fs.writeFileSync(configPath, JSON.stringify(data, null, 2), 'utf8');
        }
        catch (e) { }
    },
    /**
     * 检查当前系统是否已安装 Ollama
     * @returns 是否已安装
     */
    async isOllamaInstalled() {
        cli_core_1.CLI.loading.info('正在检测 Ollama 是否已安装...');
        try {
            const cmd = os.platform() === 'win32' ? 'where ollama' : 'which ollama';
            const result = await cli_core_1.ChildProcess.runCmdLive(cmd);
            if (result === 0) {
                cli_core_1.CLI.loading.succeed('检测 Ollama 结束');
                return true;
            }
            else {
                cli_core_1.CLI.loading.fail('检测 Ollama 失败');
                return false;
            }
        }
        catch (e) {
            cli_core_1.CLI.loading.fail('检测 Ollama 异常:\n' + e);
            return false;
        }
    },
    /**
     * 检查本地是否已存在指定的大模型
     * @param modelName 模型名称
     * @returns 是否存在
     */
    async isModelExist(modelName) {
        cli_core_1.CLI.loading.start(`正在检测模型 ${modelName} 是否存在...`);
        try {
            const result = await cli_core_1.ChildProcess.runCmdAsync('ollama list');
            if (result.status === 'success') {
                if (result.data && result.data.includes(modelName)) {
                    cli_core_1.CLI.loading.succeed(`模型 ${modelName} 已存在`);
                    return true;
                }
                cli_core_1.CLI.loading.succeed(`模型 ${modelName} 不存在`);
                return false;
            }
            else {
                cli_core_1.CLI.loading.fail('检测模型失败');
                return false;
            }
        }
        catch (e) {
            cli_core_1.CLI.loading.fail('检测模型异常:\n' + e);
        }
        return false;
    },
    /**
     * 检查并确保 Linux 系统安装了 zstd 依赖（仅在未安装时触发安装）
     */
    async ensureZstdInstalled() {
        if (os.platform() !== 'linux')
            return;
        try {
            cli_core_1.CLI.loading.start(`检测 zstd 是否存在...`);
            const res = await cli_core_1.ChildProcess.runCmdAsync('zstd --version');
            if (res.status === 'success' &&
                res.data &&
                !res.data.toLowerCase().includes('not found') &&
                !res.data.toLowerCase().includes('no such') &&
                !res.data.toLowerCase().includes('command not found')) {
                cli_core_1.CLI.loading.info(`zstd不存在`);
                return;
            }
        }
        catch (e) {
            cli_core_1.CLI.loading.fail(`检测zstd发生异常:\n` + e);
        }
        try {
            cli_core_1.CLI.loading.start(`检测 apt-get ...`);
            const aptCheck = await cli_core_1.ChildProcess.runCmdAsync('which apt-get');
            if (aptCheck.status === 'success' && aptCheck.data.length > 0) {
                await cli_core_1.ChildProcess.runCmdLive('sudo apt-get update && sudo apt-get install -y zstd');
                cli_core_1.CLI.loading.succeed(`zstd 安装成功`);
                return;
            }
            cli_core_1.CLI.loading.start(`检测 dnf ...`);
            const dnfCheck = await cli_core_1.ChildProcess.runCmdAsync('which dnf');
            if (dnfCheck.status === 'success' && dnfCheck.data.length > 0) {
                await cli_core_1.ChildProcess.runCmdLive('sudo dnf install -y zstd');
                cli_core_1.CLI.loading.succeed(`zstd 安装成功`);
                return;
            }
            cli_core_1.CLI.loading.start(`检测 yum ...`);
            const yumCheck = await cli_core_1.ChildProcess.runCmdAsync('which yum');
            if (yumCheck.status === 'success' && yumCheck.data.length > 0) {
                await cli_core_1.ChildProcess.runCmdLive('sudo yum install -y zstd');
                cli_core_1.CLI.loading.succeed(`zstd 安装成功`);
                return;
            }
            cli_core_1.CLI.loading.start(`检测 pacman ...`);
            const pacmanCheck = await cli_core_1.ChildProcess.runCmdAsync('which pacman');
            if (pacmanCheck.status === 'success' && pacmanCheck.data.length > 0) {
                await cli_core_1.ChildProcess.runCmdLive('sudo pacman -S --noconfirm zstd');
                cli_core_1.CLI.loading.succeed(`zstd 安装成功`);
                return;
            }
        }
        catch (err) {
            cli_core_1.CLI.loading.fail(`zstd 安装失败:\n` + err);
        }
    },
    /**
     * 跨平台自动安装 Ollama
     * @returns 异步返回状态码
     */
    async installOllama() {
        if (await this.isOllamaInstalled()) {
            cli_core_1.CLI.loading.info(`ollama 已安装`);
            return 0;
        }
        const platform = os.platform();
        let script = '';
        if (platform === 'linux') {
            await this.ensureZstdInstalled();
            script = 'curl -fsSL https://ollama.com/install.sh | sh';
        }
        else if (platform === 'darwin') {
            script = 'curl -fsSL https://ollama.com/install.sh | sh';
        }
        else if (platform === 'win32') {
            script = 'powershell -Command "irm https://ollama.com/install.ps1 | iex"';
        }
        else {
            cli_core_1.CLI.loading.fail(`不支持的操作系统平台: ${platform}`);
        }
        return await cli_core_1.ChildProcess.runCmdLive(script);
    },
    /**
     * 配置 Ollama 环境变量与系统服务（统一保存到用户家目录的 config.json 中，通过 PM2 运行时注入）
     * @param options 配置选项对象
     */
    async setupEnvironment(options) {
        cli_core_1.CLI.loading.start(`配置保存中...`);
        const modelPath = options.modelPath ? options.modelPath.trim() : '';
        const origins = options.origins ? options.origins.trim() : '*';
        // 统一持久化存储到用户目录下的 .coda/config.json 中
        this.saveOllamaConfig({ modelPath, origins });
        cli_core_1.CLI.loading.succeed(`Ollama 基础配置已成功保存`);
        cli_core_1.CLI.loading.info(`配置路径: ${this.getConfigPath()}`);
        cli_core_1.CLI.loading.info(`OLLAMA_MODELS = ${modelPath || '(默认系统路径)'}`);
        cli_core_1.CLI.loading.info(`OLLAMA_ORIGINS = ${origins}`);
        cli_core_1.CLI.loading.info(`提示：这些配置将在您执行 "coda start server" 时自动通过 PM2 托管生效。`);
    },
    /**
     * 等待 Ollama 服务启动就绪
     * @param maxRetries 最大重试次数
     * @returns 是否就绪
     */
    async waitForOllamaReady() {
        cli_core_1.CLI.loading.start(`ollama 服务运行状态检测中...`);
        try {
            const res = await cli_core_1.ChildProcess.runCmdAsync('ollama list');
            if (res.status === 'success') {
                cli_core_1.CLI.loading.succeed(`ollama 服务已运行`);
                return true;
            }
        }
        catch (err) {
            cli_core_1.CLI.loading.fail(`ollama 服务运行状态检测异常:\n` + err);
            return false;
        }
        cli_core_1.CLI.loading.fail(`ollama 服务未运行`);
        return false;
    },
    /**
     * 拉取指定的开源大模型（实时流式输出下载进度）
     * @param modelName 模型名称
     * @returns 异步返回状态码
     */
    async pullModel(modelName) {
        await this.waitForOllamaReady();
        cli_core_1.CLI.loading.info(`拉取模型 ${modelName} ...`);
        return await cli_core_1.ChildProcess.runCmdLive(`ollama pull ${modelName}`);
    },
    /**
     * 验证大模型服务网关是否连通
     * @param baseUrl 服务地址
     * @returns 是否连通
     */
    async verifyOllamaServiceConnection(baseUrl) {
        try {
            const cleanBaseUrl = baseUrl.replace(/\/$/, '');
            const healthUrl = `${cleanBaseUrl}/api/tags`;
            const res = await fetch(healthUrl, { method: 'GET' });
            return res.status < 500;
        }
        catch {
            return false;
        }
    },
    /**
     * 跨平台打开浏览器访问指定链接
     * @param url 目标网址
     */
    async openBrowser(url) {
        const platform = process.platform;
        let cmd = '';
        if (platform === 'win32') {
            cmd = `start ${url}`;
        }
        else if (platform === 'darwin') {
            cmd = `open ${url}`;
        }
        else {
            cmd = `xdg-open ${url}`;
        }
        await cli_core_1.ChildProcess.runCmdAsync(cmd);
    },
    /**
     * 计算字符串在终端中的实际显示宽度
     * @param str 目标字符串
     * @returns 显示宽度
     */
    getDisplayWidth(str) {
        let width = 0;
        for (const char of str) {
            if (char.charCodeAt(0) > 127) {
                width += 2;
            }
            else {
                width += 1;
            }
        }
        return width;
    },
    /**
     * 右侧填充对齐
     */
    padEndDisplay(str, targetWidth) {
        const currentWidth = this.getDisplayWidth(str);
        const diff = targetWidth - currentWidth;
        return str + ' '.repeat(Math.max(0, diff));
    },
    /**
     * 通用终端动态表格打印函数
     */
    printTerminalTable(title, headers, rows) {
        const numCols = headers.length;
        const colWidths = headers.map((header, colIndex) => {
            const maxLen = Math.max(this.getDisplayWidth(header), ...rows.map(row => this.getDisplayWidth(row[colIndex] || '')));
            return maxLen + 2;
        });
        let totalInnerWidth = colWidths.reduce((sum, w) => sum + w, 0) + (numCols - 1);
        const paddedTitleText = ` ${title} `;
        const paddedTitleW = this.getDisplayWidth(paddedTitleText);
        if (paddedTitleW > totalInnerWidth) {
            const diff = paddedTitleW - totalInnerWidth;
            colWidths[colWidths.length - 1] += diff;
            totalInnerWidth = paddedTitleW;
        }
        const topBorder = `┌${'─'.repeat(totalInnerWidth)}┐`;
        const titleSeparator = `├${colWidths.map(w => '─'.repeat(w)).join('┬')}┤`;
        const midBorder = `├${colWidths.map(w => '─'.repeat(w)).join('┼')}┤`;
        const btmBorder = `└${colWidths.map(w => '─'.repeat(w)).join('┴')}┘`;
        const leftPad = Math.floor((totalInnerWidth - paddedTitleW) / 2);
        const rightPad = totalInnerWidth - paddedTitleW - leftPad;
        const finalTitleLine = ' '.repeat(Math.max(0, leftPad)) + paddedTitleText + ' '.repeat(Math.max(0, rightPad));
        cli_core_1.CLI.log.info('');
        cli_core_1.CLI.log.info(topBorder);
        cli_core_1.CLI.log.info(`│${finalTitleLine}│`);
        cli_core_1.CLI.log.info(titleSeparator);
        const headerStr = headers.map((h, i) => this.padEndDisplay(h, colWidths[i])).join('│');
        cli_core_1.CLI.log.info(`│${headerStr}│`);
        cli_core_1.CLI.log.info(midBorder);
        rows.forEach(row => {
            const rowStr = row.map((cell, i) => this.padEndDisplay(cell || '', colWidths[i])).join('│');
            cli_core_1.CLI.log.info(`│${rowStr}│`);
        });
        cli_core_1.CLI.log.info(btmBorder + '\n');
    },
    /**
     * 获取产物目录路径
     * @returns 包含 serverPath 和 serverDir 的对象
     */
    getAgentServerPaths() {
        let res = {
            serverPath: path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'servers', 'agent-server', 'main.js'),
            serverDir: path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'servers', 'agent-server'),
        };
        return res;
    },
    /**
     * 启动 Agent Server 基于 PM2
     * @returns 启动是否成功
     */
    async startAgentWithPM2() {
        const { serverPath, serverDir } = this.getAgentServerPaths();
        if (!fs.existsSync(serverPath)) {
            cli_core_1.CLI.loading.fail(`找不到 Agent Server 入口文件: ${serverPath}`);
            return false;
        }
        const pm2Output = path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'servers', 'agent-server', 'server-out.log');
        const pm2Error = path.join(process.env.cliRoootPath || '', process.env.DEBUG_ENV === 'true' ? 'dist' : '', 'servers', 'agent-server', 'server-err.log');
        return await cli_api_1.PM2.startServiceWithPm2({
            script: serverPath,
            name: types_1.ServerNames.agnet,
            cwd: serverDir,
            env: {
                ...process.env,
                PORT: '10086',
                NODE_ENV: 'production',
            },
            outputFile: pm2Output,
            errorFile: pm2Error,
        });
    },
    /**
     * 通过内置 PM2 编程 API 在后台拉起并托管 Ollama 服务（自动注入用户配置的环境变量）
     * @returns 是否启动成功
     */
    async startOllamaWithPm2() {
        const ollamaConfig = this.getOllamaConfig();
        const env = { ...process.env };
        if (ollamaConfig.modelPath) {
            env.OLLAMA_MODELS = ollamaConfig.modelPath;
        }
        if (ollamaConfig.origins) {
            env.OLLAMA_ORIGINS = ollamaConfig.origins;
        }
        return await cli_api_1.PM2.startServiceWithPm2({
            script: 'ollama',
            args: ['serve'],
            name: types_1.ServerNames.ollama,
            env,
        });
    },
    /**
     * 启动AI服务
     * @param serverNames 服务名称枚举
     */
    async startServerFlow(serverNames) {
        cli_core_1.CLI.loading.info(`正在检查 ${serverNames} 服务运行情况...`);
        // 1. 使用内置 PM2 API 检查目标服务状态
        const { exists, online } = await cli_api_1.PM2.getServerStatusWithPM2(serverNames);
        // 2. 不存在则启动服务
        if (!exists) {
            cli_core_1.CLI.loading.info(`PM2 进程列表中未发现 ${serverNames} 服务`);
            cli_core_1.CLI.loading.info(`${serverNames} 启动...`);
            if (serverNames === types_1.ServerNames.ollama) {
                const isOllamaInstalled = await exports.AIUtil.isOllamaInstalled();
                if (isOllamaInstalled) {
                    return await this.startOllamaWithPm2();
                }
                else {
                    cli_core_1.CLI.loading.fail('本地未检测到 Ollama，无法通过 PM2 启动');
                    return false;
                }
            }
            if (serverNames === types_1.ServerNames.agnet) {
                return await this.startAgentWithPM2();
            }
        }
        else {
            // 3. 存在则检测在线状态
            cli_core_1.CLI.loading.info(`服务 ${serverNames} 状态: ${online ? '在线 (Online)' : '离线 (Offline)'}`);
            if (online) {
                cli_core_1.CLI.loading.succeed(`${serverNames} 已经在后台正常运行中，无需重复启动`);
                return true;
            }
            else {
                if (serverNames === types_1.ServerNames.ollama) {
                    const isOllamaInstalled = await exports.AIUtil.isOllamaInstalled();
                    if (isOllamaInstalled) {
                        return await this.startOllamaWithPm2();
                    }
                    else {
                        cli_core_1.CLI.loading.fail('本地未检测到 Ollama，无法通过 PM2 启动');
                        return false;
                    }
                }
                if (serverNames === types_1.ServerNames.agnet) {
                    return await this.startAgentWithPM2();
                }
            }
        }
        return false;
    },
    /**
     * 关闭AI服务
     * @param serverName 服务名称
     * @returns 是否成功
     */
    async stopServerFlow(serverName) {
        cli_core_1.CLI.loading.start(`正在检查 ${serverName} 运行情况...`);
        // 1. 使用内置 PM2 API 检查目标服务状态
        const { exists, online } = await cli_api_1.PM2.getServerStatusWithPM2(serverName);
        if (!exists) {
            cli_core_1.CLI.loading.info(`PM2 进程列表中未发现 ${serverName} 服务`);
            return false;
        }
        // 2. 存在服务（无论在线或离线），统一进行删除与清理
        const statusDesc = online
            ? '正在运行，正在从PM2中卸载并关闭'
            : '处于离线状态，正在清理历史记录';
        cli_core_1.CLI.loading.start(`检测到 ${serverName} ${statusDesc}...`);
        try {
            const success = await cli_api_1.PM2.removeServerWithPM2(serverName);
            if (success) {
                cli_core_1.CLI.loading.succeed(`${serverName} 已成功从PM2中卸载并清理完毕`);
                return true;
            }
            else {
                cli_core_1.CLI.loading.fail('PM2 delete 动作执行返回异常');
            }
        }
        catch (err) {
            cli_core_1.CLI.loading.fail(`卸载/清理服务异常: ${err.message}`);
            return false;
        }
        return false;
    },
};
exports.default = exports.AIUtil;
